module.exports = __webpack_public_path__ + "img/logo.e81f0b19.png";